var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0H12.5C5.5975 0 0 5.5975 0 12.5V27.5C0 34.4025 5.5975 40 12.5 40H27.5C34.4025 40 40 34.4025 40 27.5V12.5C40 5.5975 34.4025 0 27.5 0ZM36.25 27.5C36.25 32.325 32.325 36.25 27.5 36.25H12.5C7.675 36.25 3.75 32.325 3.75 27.5V12.5C3.75 7.675 7.675 3.75 12.5 3.75H27.5C32.325 3.75 36.25 7.675 36.25 12.5V27.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C14.4775 10 10 14.4775 10 20C10 25.5225 14.4775 30 20 30C25.5225 30 30 25.5225 30 20C30 14.4775 25.5225 10 20 10ZM20 26.25C16.555 26.25 13.75 23.445 13.75 20C13.75 16.5525 16.555 13.75 20 13.75C23.445 13.75 26.25 16.5525 26.25 20C26.25 23.445 23.445 26.25 20 26.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 10.5825C31.4859 10.5825 32.0825 9.98589 32.0825 9.24998C32.0825 8.51406 31.4859 7.91748 30.75 7.91748C30.0141 7.91748 29.4175 8.51406 29.4175 9.24998C29.4175 9.98589 30.0141 10.5825 30.75 10.5825Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramClient);
export default __webpack_public_path__ + "static/media/instagram-client.3f66d2eef36cb44976e2a0e85f485c9e.svg";
export { ForwardRef as ReactComponent };